import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LayoutsModule } from './layouts/layouts.module';
import { PagesModule } from './pages/pages.module';
import { LayoutMobilesModule } from './layouts-mobile/layouts-mobile.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeVi from '@angular/common/locales/vi';

import { CommonService } from './shared/services/common.service';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { ErrorInterceptor } from './core/helpers/error.interceptor';

import { Router } from '@angular/router';

// i18n loader
export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

// Launch startup service
export function StartupServiceFactory(startupService: CommonService) {
  return () => startupService.loaderService();
}

registerLocaleData(localeVi);

// ✅ Khởi tạo Sentry



@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PagesModule,
    LayoutsModule,
    LayoutMobilesModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'vi' },

    // ✅ Load service khởi động
    {
      provide: APP_INITIALIZER,
      useFactory: StartupServiceFactory,
      deps: [CommonService],
      multi: true,
    },

    // ✅ Bắt lỗi toàn hệ thống với Sentry

    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      multi: true,
    },

    // ✅ Interceptor cũ vẫn giữ nguyên
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
